<ng-container *ngIf="canAccess; else noAccess">
<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <a class="navbar-brand">Tasks</a>

  <span class="mr-auto">
    <button mat-raised-button class="m-1 mr-2" color="primary" (click)="onEdit()" id="add" *ngIf="canEdit">
      <mat-icon>add</mat-icon>
      Add Note
    </button>
  </span>

  <form tourAnchor="tour.search" class="form-inline mx-1 my-0" (ngSubmit)="dataSource.getData(true)">
    <input
      class="form-control ml-0 mr-2 my-1"
      type="search"
      [(ngModel)]="dataSource.search"
      name="search"
      placeholder="Search"
      aria-label="Search" />

    <button
      mat-raised-button
      color="secondary"
      type="submit"
      class="mx-0 my-1">
      <mat-icon>search</mat-icon> Search
    </button>
  </form>
</nav>

<div class="mat-elevation-z8 scroll-box">
  <table mat-table [dataSource]="dataSource" style="width: 100%" matSort matSortActive="name" matSortDisableClear>

    <ng-container matColumnDef="id">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        #
      </th>
      <td mat-cell *matCellDef="let note" class="no-padding text-wrap">
        {{ note.id }}
      </td>
    </ng-container>

    <ng-container matColumnDef="note">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Note
      </th>
      <td mat-cell *matCellDef="let note" class="no-padding text-wrap">
        {{ note.note }}
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At/By
      </th>
      <td mat-cell *matCellDef="let note" class="no-padding">
        <p>
          {{ (note.date_created * 1000) | timezoneConvertMedium }} <br>
          <span *ngIf="note?.creator">
            <a (click)="onUserPublicView(note.creator.hash)"
                 matTooltip="View User Public Profile">
              {{ note.creator.contact_person }}
            </a>
          </span>
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="date_created_UTC">
      <th mat-header-cell *matHeaderCellDef class="no-padding" mat-sort-header>
        Created At/By (UTC)
      </th>
      <td mat-cell *matCellDef="let note" class="no-padding">
        <p>
          {{ (note.date_created * 1000) | timezoneConvertUTCMedium }} <br>
          <span *ngIf="note?.creator">{{ note.creator.contact_person }}</span>
        </p>
      </td>
    </ng-container>

    <ng-container matColumnDef="buttons">
      <th mat-header-cell *matHeaderCellDef [style.width.px]="160"></th>

      <td mat-cell *matCellDef="let note">
        <button type="button" mat-button (click)="onEdit(note.id)" *ngIf="canEdit">
          Edit
        </button>

        <button type="button" mat-button (click)="onDelete(note.id)" *ngIf="canEdit">
          Delete
        </button>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    class="my-2 ml-1 mr-2"
    [length]="dataSource?.total | async"
    [pageSize]="dataSource.limit"
    [pageSizeOptions]="dataSource.pageSizeOptions"
    showFirstLastButtons>
  </mat-paginator>
</div>
</ng-container>

<ng-template #noAccess>
  <div class="alert alert-warning m-3">
    <mat-icon class="align-middle mr-2">info</mat-icon>
    You do not have permission to view task notes.
  </div>
</ng-template>
